import { Component, Input } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { AbstractComponent } from '../../shared/components/abstract-component/abstract.component';
import { ListLoader } from '../../shared/components/list-loader/list-loader';
import { AvBemerkungMasterDetailEntry, AvBemerkungVersionDetailEntry } from '../../core/av-api';
import { TableSortModel } from '../../shared/tablesort/tableSortModel';
import { ComparatorService } from '../../shared/services/comparator-service';
import { ListLoaderWrapperComponent } from '../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { HistoryDirective } from 'app/shared/directives/history.directive';
import { KompaktTimepointComponent } from 'app/shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { TranslatePipe } from '@ngx-translate/core';
import { AvbemerkungArtPipe } from '../../shared/pipes/simple/avbemerkung-art.pipe';
import ArtEnum = AvBemerkungVersionDetailEntry.ArtEnum;

@Component({
  selector: 'cap-avbemerkung-table-icp',
  templateUrl: './avbemerkung-table-icp.component.html',
  imports: [ListLoaderWrapperComponent, NgTemplateOutlet, HistoryDirective, KompaktTimepointComponent, TranslatePipe, AvbemerkungArtPipe]
})
export class AvbemerkungTableIcpComponent extends AbstractComponent {
  private _listLoader: ListLoader<AvBemerkungMasterDetailEntry>;
  private tableSortModel = new TableSortModel<AvBemerkungMasterDetailEntry>('table', this.comparatorService);

  constructor(private comparatorService: ComparatorService) {
    super();
    keysToTranslate<ArtEnum>(['NATURDENKMAL', 'LAGEFIXPUNKT', 'STREITIGE_GRENZE', 'EINGEDOLTES_GEWAESSER', 'ANDERE']);
    this.tableSortModel
      .addColumn('art', (a, b) => this.comparatorService.avBemerkungMasterDetailEntryComparator(a, b))
      .switchSortDirection();
  }

  @Input()
  set listLoader(listLoader: ListLoader<AvBemerkungMasterDetailEntry>) {
    if (!listLoader) {
      return;
    }
    this._listLoader = listLoader;
    this._listLoader.applySortModel(this.tableSortModel);
  }

  get listLoader(): ListLoader<AvBemerkungMasterDetailEntry> {
    return this._listLoader;
  }
}
